import * as actionTypes from './RegistrationActionTypes';
import * as serviceEndPoint from '../../../../SharedModule/Service/service';
import axios from 'axios';

export const ValidateRegistrationActions = (value) => {
  return dispatch => {
    return axios.post(`${serviceEndPoint.VALIDATE_REGISTRATION}`, value)
      .then(response => {
        dispatch(ValidateRegistration(response.data));
      })
      .catch(error => {
        dispatch(ValidateRegistration({ systemFailure: true }));
      });
  };
};
export const ValidateRegistration = (validateRegistration) => {
  return ({
    type: actionTypes.VALIDATE_REGISTRATION,
    validateRegistration: validateRegistration
  });
};

export const GetRegistrationOptionsActions = (value) => {
  return dispatch => {
    return axios.post(`${serviceEndPoint.REGISTRATION_OPTIONS}`, value)
      .then(response => {
        dispatch(GetRegistrationOptions(response.data));
      })
      .catch(error => {
        dispatch(GetRegistrationOptions({ systemFailure: true }));
      });
  };
};
export const GetRegistrationOptions = (registrationOptions) => {
  return ({
    type: actionTypes.REGISTRATION_OPTIONS,
    registrationOptions: registrationOptions
  });
};

export const ValidateRegistrationOptionsActions = (value) => {
  return dispatch => {
    return axios.post(`${serviceEndPoint.VALIDATE_REGISTRATION_OPTIONS}`, value)
      .then(response => {
        dispatch(ValidateRegistrationOptions(response.data));
      })
      .catch(error => {
        dispatch(ValidateRegistrationOptions({ systemFailure: true }));
      });
  };
};
export const ValidateRegistrationOptions = (validateRegistrationOptions) => {
  return ({
    type: actionTypes.VALIDATE_REGISTRATION_OPTIONS,
    validateRegistrationOptions: validateRegistrationOptions
  });
};

export const VerifyVerificationCodeActions = (value) => {
  return dispatch => {
    return axios.post(`${serviceEndPoint.VERIFY_VERIFICATION_CODE}`, value)
      .then(response => {
        dispatch(VerifyVerificationCode(response.data));
      })
      .catch(error => {
        dispatch(VerifyVerificationCode({ systemFailure: true }));
      });
  };
};
export const VerifyVerificationCode = (verifyVerificationCode) => {
  return ({
    type: actionTypes.VERIFY_VERIFICATION_CODE,
    verifyVerificationCode: verifyVerificationCode
  });
};

export const ResendVerificationCodeActions = (value) => {
  return dispatch => {
    return axios.post(`${serviceEndPoint.RESEND_VERIFICATION_CODE}`, value)
      .then(response => {
        dispatch(ResendVerificationCode(response.data));
      })
      .catch(error => {
        dispatch(ResendVerificationCode({ systemFailure: true }));
      });
  };
};
export const ResendVerificationCode = (resendVerificationCode) => {
  return ({
    type: actionTypes.RESEND_VERIFICATION_CODE,
    resendVerificationCode: resendVerificationCode
  });
};

export const ResendEmailActions = (value) => {
  return dispatch => {
    return axios.post(`${serviceEndPoint.RESEND_EMAIL}`, value)
      .then(response => {
        dispatch(ResendEmail(response.data));
      })
      .catch(error => {
        dispatch(ResendEmail({ systemFailure: true }));
      });
  };
};
export const ResendEmail = (resendEmail) => {
  return ({
    type: actionTypes.RESEND_EMAIL,
    resendEmail: resendEmail
  });
};

export const resetRegistrationData = (key) => {
  return {
    type: actionTypes.RESET_REGISTRATION_DATA,
    key: key
  };
};